import {ErrorHandler} from "@angular/core";

export class MyErrorHandler implements ErrorHandler {
  private _to: any;

  constructor(
  ){
  }

  handleError(err: any): void {
    // do something with the error
    console.log(err);

    // if(this._to){
    //   clearTimeout(this._to);
    //   this._to = null;
    // }

    // this._to = setTimeout(() => {
    //   try {
    //     //window.location.href = "/";
    //     //this.app.rootPage = 'HomePage';
    //     //this.navCtrl.setRoot('HomePage').catch(e => {throw e;});
    //   }
    //   catch(e){
    //     console.log(e);
    //     //throw e;
    //   }
    // }, 20);
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/MyErrorHandler.ts